import { Component, OnInit } from '@angular/core';;
import { PlatformLocation  } from '@angular/common';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AdvanceSearchService } from './layout/components/search-advanced/services/advance-search.service';
import { FeatureFlagV3Service } from './shared/services/feature-flags-v3.service';
import { NavigationService } from '@utils/navigation.service';
import { LocalStorage } from 'ngx-webstorage';
import { IUser } from './core/models/interfaces/i-user.interface';
import { environment as ENV } from '@environment/environment';
import { UserStateService } from './shared/services/user-state.service';
import { GtmService } from './shared/services/lib/gtm.service';
import { MarketingParamsService } from './shared/utils/marketing-params.service';
import { LastSearchService } from './shared/utils/last-search.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  @LocalStorage('user')
  private user: IUser;
  isPray = true;
  private _ignoreUrls = [
    '/acquire',
    '/video',
    '/podcast',
    '/auth',
    '/program',
    '/home/ebook'
  ];
  private history: string[] = [];
  private currentIndex: number = -1;
  private targetUrl = '/search-v2';

  constructor(
    private router: Router,
    private featureFlagsService: FeatureFlagV3Service,
    private advanceSearchService: AdvanceSearchService,
    private route: ActivatedRoute,
    public navigation: NavigationService,
    private userService: UserStateService,
    private gtmService: GtmService,
    private marketingParamsService: MarketingParamsService,
    private platformLocation: PlatformLocation,
    private lastSearchService: LastSearchService) {
    this.advanceSearchService.previousUrl = this.router.url;
  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
        this.currentIndex = this.history.length - 1;
        this.handleMarketingTracking(event.url);
        this.isPray = !event.url.includes('watch');
        const url = event.urlAfterRedirects;
        const userId = this.user?.id ?? null;
        this.advanceSearchService.previousUrl = event.url;
        // this.navigation.history.push(event.urlAfterRedirects);
        if (!this.shouldFilterURL(url)) {
          this.gtmService.logPageView(url, userId, ENV.name);
        }
        window.scrollTo(0, 0)
      }
    });
    this.detectBackNavigation();
  }

  detectBackNavigation(): void {
    this.platformLocation.onPopState(() => {
      const previousIndex = this.currentIndex;
      if (previousIndex > 0 && previousIndex > --this.currentIndex) {
        const currentUrl = this.history[this.currentIndex];
        if (currentUrl === this.targetUrl) {
          this.lastSearchService.setSearchBack(true);
        }
      }
    });
  }

  private shouldFilterURL(url: string): boolean {
    const filterKeywords = ['/mobile'];
    const queryParams = this.route.snapshot.queryParams;

    if (filterKeywords.some(keyword => window.location.href.includes(keyword))) {
      return true;
    }

    if (queryParams.fromMobile) {
      return true;
    }

    return false;
  }

  get isOlder14(): boolean {
    return this.userService.userIsOlderThan13();
  }

  get hasFeaturesLoaded(): boolean {
    return this.featureFlagsService.areThereFeatures;
  }

  get isComunityEnabled(): boolean{
    return this.featureFlagsService.checkFeatureOn('WebEnableCommunity');
  }

  private handleMarketingTracking(url: string): void {
    const queryParams = this.marketingParamsService.getQueryParamsMarketing();
    if (queryParams) {
      this.marketingParamsService.sendMarketingTrack({
        event_location: ''
      });
    }
  }

  private shouldIgnore(url: string): boolean {
    return this._ignoreUrls.some(ignoredUrl => url.includes(ignoredUrl));
  }


}
